// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d8e902a0","703":"98c1e522","787":"1097b423"}[chunkId] + ".chunk.js";
};